import React, { Component } from 'react'
import { Icon } from 'antd'
import Details from './Details'

export default class Detail extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { serviceClinics } = this.props
        if (serviceClinics.length) {
            let title
            if (serviceClinics.length === 1) {
                title = serviceClinics[0].name
            } else {
                title = `נמצאו ${serviceClinics.length} תחומי שירות `
            }
            return (
                <div style={{ cursor: 'pointer' }}>
                    <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                        <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                        <span>{title}</span>
                    </div>
                    <div
                        style={{
                            display: `${this.state.open ? 'flex' : 'none'}`,
                            paddingRight: '1.5rem',
                            flexDirection: 'column'
                        }}
                    >
                        <div>
                            {serviceClinics.map((serviceClinic, index) => (
                                <span key={index}>
                                    <Details {...serviceClinic} />
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )
        } else {
            return <span>לא נמצאו מרפאות</span>
        }
    }
}
